import React from 'react';
import ReactDOM from "react-dom";

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.closeVideo = this.closeVideo.bind(this);
    }

    componentDidMount() {
        // Prevent body from scrolling
        document.body.classList.add("modal-open");
    }

    componentWillUnmount() {
        // Let body scroll again
        document.body.classList.remove("modal-open");
    }

    closeVideo() {
        this.props.onClose();
        this.refs.vidRef.pause();
    }

    render() {
        const opts = {
            height: '390',
            width: '640',
            playerVars: {
                autoplay: 1
            }
        };
        let videoUrl = "https://player.vimeo.com/video/" + this.props.videoId;
        const videoPlayerLauncher =
            <div className={this.props.isOpen ? "modal-video video-show" : "modal-video video-out"}>
                <a className="close-modal-video" onClick={this.closeVideo} alt="Close Video">X<span class="visuallyhidden">Close Video</span></a>
                <iframe src={videoUrl} frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>;

        return ReactDOM.createPortal(
            videoPlayerLauncher,
            document.getElementById('video-launcher'),
        );    
    }
}

export default VideoPlayer;
